const initGalleryTabs = () => {
    const tabBlocks = document.querySelectorAll('.js-gallery-tabs');

    if (!tabBlocks.length) return;

    tabBlocks.forEach(block => {
        const buttons = block.querySelectorAll('.js-gallery-tab-btn');
        const panes = block.querySelectorAll('.js-gallery-pane');

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                if (btn.classList.contains('is-active')) return;

                const targetIndex = btn.dataset.tab;

                buttons.forEach(b => b.classList.remove('is-active'));
                panes.forEach(p => p.classList.remove('is-active'));

                btn.classList.add('is-active');
                
                const targetPane = block.querySelector(`.js-gallery-pane[data-tab="${targetIndex}"]`);
                if (targetPane) {
                    targetPane.classList.add('is-active');
                }
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', initGalleryTabs);